import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileExplorerComponent } from './file-explorer/file-explorer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
    AudioPlayComponent,
    AudioRecordComponent,
    CameraComponent,
    ImageViewerComponent,
    RecordRtcComponent,
    SpeechNoteComponent,
} from './modals';
import { provideI18nConfig } from 'app/config';

@NgModule({
    imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        BrowserAnimationsModule,
        MatDialogModule,
        MatInputModule,
        MatGridListModule,
        FormsModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressBarModule,
        FileExplorerComponent,
        RecordRtcComponent,
        CameraComponent,
        ImageViewerComponent,
        AudioRecordComponent,
        AudioPlayComponent,
        SpeechNoteComponent,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi(), withFetch()), provideI18nConfig()],
    exports: [FileExplorerComponent],
})
export class FileExplorerModule {}
